// extracted by mini-css-extract-plugin
export default {"root":"FullModal_root__paVgn"};